import React from 'react';
import { Routes, Route } from 'react-router-dom';
import PrivateRoute from './components/auth/PrivateRoute';

// 页面组件
import LandingPage from './pages/LandingPage';
import LoginPage from './pages/LoginPage';
import RegisterPage from './pages/RegisterPage';
import ResetPasswordPage from './pages/ResetPasswordPage';
import JDManagementPage from './pages/JDManagementPage';
import EvaluationFormPage from './pages/EvaluationFormPage';
import EvaluationListPage from './pages/EvaluationListPage';
import EvaluationDetailPage from './pages/EvaluationDetailPage';
import NotFoundPage from './pages/NotFoundPage';

const AppRoutes = () => {
  return (
    <Routes>
      {/* 公开路由 */}
      <Route path="/" element={<LandingPage />} />
      <Route path="/login" element={<LoginPage />} />
      <Route path="/register" element={<RegisterPage />} />
      
      {/* 私有路由 */}
      <Route path="/reset-password" element={
        <PrivateRoute>
          <ResetPasswordPage />
        </PrivateRoute>
      } />
      <Route path="/jds" element={
        <PrivateRoute>
          <JDManagementPage />
        </PrivateRoute>
      } />
      <Route path="/evaluate" element={
        <PrivateRoute>
          <EvaluationFormPage />
        </PrivateRoute>
      } />
      <Route path="/evaluations" element={
        <PrivateRoute>
          <EvaluationListPage />
        </PrivateRoute>
      } />
      <Route path="/evaluations/:id" element={
        <PrivateRoute>
          <EvaluationDetailPage />
        </PrivateRoute>
      } />
        
      {/* 404页面 */}
      <Route path="*" element={<NotFoundPage />} />
    </Routes>
  );
};

export default AppRoutes;
